<template>
	<div class="flex h-screen p-5 gap-5 bg-muted/40 bg-background">
		<AvailablePanel @add="addComponent" />

		<GridLayout v-model:layout="layout" :col-num="6" :row-height="105" :is-draggable="true" :is-resizable="true" :margin="[16, 16]" :vertical-compact="false" :use-css-transforms="true" class="flex-1  p-4 " :auto-size="true" >
		<GridItem v-for="item in layout" :key="item.i" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" class="bg-none  p-1 relative"> 
		<div class="w-full h-full pointer-events-none">
			<component :is="getComponent(item.type)" :data="item.data" size="small" :height="item.h" />
		</div>
		<button class="absolute top-2 right-2 text-sm bg-red-500 text-white rounded px-2" @click="removeItem(item.i)" >
			✕
		</button>
		</GridItem>
		</GridLayout>
	</div>
</template>

<script setup lang="ts">
import { Ref,inject,ref,watch,onMounted } from 'vue'
import { GridLayout, GridItem } from 'vue3-grid-layout'
import { componentMap } from '@/data/dashboard'
import AvailablePanel from './AvailablePanel.vue'
import type  { DashboardComponent } from '@/types/dashboard'
import {updateUser} from '@/services/User'
import {Member} from '@/types/Member'

const GRID_COLS = 6

const userInfo = inject<Ref<Member> | null>('userInfo', null);
function findFirstFreePosition(layout: any[], colNum = 6, itemW = 2, itemH = 2) {
	const occupied = new Set<string>()

	// mark all occupied cells
	layout.forEach(item => {
		for (let dx = 0; dx < item.w; dx++) {
			for (let dy = 0; dy < item.h; dy++) {
				occupied.add(`${item.x + dx},${item.y + dy}`)
			}
		}
	})

	// search for first position that fits itemW x itemH
	for (let y = 0; y < 100; y++) { // Arbitrary max height
		for (let x = 0; x <= colNum - itemW; x++) {
			let fits = true
			for (let dx = 0; dx < itemW; dx++) {
				for (let dy = 0; dy < itemH; dy++) {
					if (occupied.has(`${x + dx},${y + dy}`)) {
						fits = false
						break
					}
				}
				if (!fits) break
			}
			if (fits) return { x, y }
		}
	}

	// fallback if nothing found
	return { x: 0, y: 0 }
}


const layout = ref<any[]>([])
//Date.now().toString(),
const addComponent = (component: DashboardComponent) => {
	const position = findFirstFreePosition(layout.value, 6, component.width, component.height)

	layout.value.push({
		i: Date.now().toString(),
		x:position.x,
		y:position.y,
		h:component.height,
		w:component.width,
		type:component.type,
		name:component.name,
		data:component.data
	})
}

watch(layout, () => {
	saveLayout()
}, { deep: true })
const saveLayout = async () => {
	const savedLayout = layout.value


	if(userInfo) {          
		const newMeta = {
			...userInfo.value.meta, 
			dashboard: savedLayout
		}       
		// Update the user's meta.dashboardChoices
		const updatedUser = await updateUser({
			meta: newMeta
		});

		return updatedUser;
	}
};

const getComponent = (type: string) => componentMap[type] || null

const removeItem = (id: string) => {
	layout.value = layout.value.filter(item => item.i !== id)
}
onMounted(async () => {
	if (!userInfo?.value?.meta?.dashboard) {
		layout.value = [] 
		return
	}               
	layout.value = userInfo.value.meta.dashboard || []
})
</script>
<style scoped>
/* Fade + Slide Down Animation */
.fade-slide-enter-from {
	opacity: 0;
	transform: translateY(-10px) scale(0.95);
}
.fade-slide-enter-active {
	transition: all 300ms ease;
}
.fade-slide-leave-to {
	opacity: 0;
	transform: scale(0.95);
}
.fade-slide-leave-active {
	transition: all 200ms ease;
}
</style>
